import autoformPlaceholder from '../images/autoform-unselected.png';
import { Navigate } from 'react-router-dom';
import AutoformPage from 'pages/AutoformPage';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import AutoformContainer from 'components/autoform/AutoformContainer';
import EconomicReserve from 'pages/EconomicReserve';
import { FormattedMessage } from 'react-intl';
import { APP_NAME } from 'constants/autoforms';
import { ECONOMIC_RESERVE_ROUTES } from 'constants/routes';

export const economicReserveRoutes = {
    path: '/economic-reserve',
    element: <EconomicReserve />,
    children: [
        {
            index: true,
            element: <Navigate to={`${ECONOMIC_RESERVE_ROUTES.PSECONRESERVE}/${window.location.search}`} />,
        },
        {
            path: ECONOMIC_RESERVE_ROUTES.PSECONRESERVE,
            element: (
                <AutoformPage
                    config={{
                        autoformId: ECONOMIC_RESERVE_ROUTES.PSECONRESERVE,
                        descriptionName: <FormattedMessage id="economic_reserve_variables" />,
                        pageTitle: `${(<FormattedMessage id="economic_reserve" />)} - ${APP_NAME}`,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: ECONOMIC_RESERVE_ROUTES.PSECONRES,
            element: (
                <AutoformPage
                    config={{
                        autoformId: ECONOMIC_RESERVE_ROUTES.PSECONRES,
                        descriptionName: <FormattedMessage id="economic_reserve_variables" />,
                        pageTitle: `${(<FormattedMessage id="economic_reserve" />)} - ${APP_NAME}`,
                        addDataModalInstructions: <FormattedMessage id="common_add_rows_sub_heading_without_date" />,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
    ],
};
